import { initializeApp as initializeApp } from 'firebase/app';
import {
  getMessaging as getMessaging,
  getToken as getToken,
  onMessage as onMessage,
} from 'firebase/messaging';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Default_getInstance27jodt8hd1bac as Default_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/debugger.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  toString1pkumu07cwy4m as toString_0,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { printStackTrace18lnx7a39cni as printStackTrace } from '../../../../../kotlin-kotlin-stdlib/kotlin/throwableExtensions.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { intercepted2ogpsikxxj4u0 as intercepted } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CancellableContinuationImpl.mjs';
import {
  Companion_instancejy2056q2ma5w as Companion_instance,
  _Result___init__impl__xyqfz832zdzqrocazzs as _Result___init__impl__xyqfz8,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { get_fcmTokenr2vb68z9flza as get_fcmToken } from '../App.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function fcmSetup() {
  try {
    var firebaseAppOptions = new (fcmSetup$firebaseAppOptions$1())();
    firebaseAppOptions['apiKey'] = 'AIzaSyCL8CNiVYE-JoF3JxJffpgHjHV8wfMdqTY';
    firebaseAppOptions['authDomain'] = 'ls-kiteui-starter-project.firebaseapp.com';
    firebaseAppOptions['projectId'] = 'ls-kiteui-starter-project';
    firebaseAppOptions['storageBucket'] = 'ls-kiteui-starter-project.firebasestorage.app';
    firebaseAppOptions['messagingSenderId'] = '763812266707';
    firebaseAppOptions['appId'] = '1:763812266707:web:3ee91ef35b45b8e70c0a26';
    // Inline function 'kotlin.js.unsafeCast' call
    var app = initializeApp(firebaseAppOptions);
    var messaging = getMessaging(app);
    var tmp = window.navigator.serviceWorker;
    // Inline function 'org.w3c.workers.RegistrationOptions' call
    // Inline function 'org.w3c.dom.CLASSIC' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.unsafeCast' call
    var o = {};
    o['scope'] = './';
    o['type'] = 'classic';
    var tmp_0 = tmp.register('firebase-messaging-sw.js', o);
    var tmp_1 = tmp_0.then((serviceWorkerReg) => {
      var tmp0_elvis_lhs = serviceWorkerReg.installing;
      var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? serviceWorkerReg.waiting : tmp0_elvis_lhs;
      var serviceWorker = tmp1_elvis_lhs == null ? serviceWorkerReg.active : tmp1_elvis_lhs;
      var tmp = Default_getInstance();
      tmp.log_iyb52q_k$(['Service worker state: ' + toString(serviceWorker == null ? null : serviceWorker.state)]);
      var tmp_0;
      var tmp_1 = serviceWorker == null ? null : serviceWorker.state;
      // Inline function 'org.w3c.workers.ACTIVATED' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp$ret$5 = 'activated';
      if (equals(tmp_1, tmp$ret$5)) {
        finishSetup(serviceWorkerReg, messaging);
        tmp_0 = Unit_instance;
      } else {
        var tmp_2;
        if (serviceWorker == null) {
          tmp_2 = null;
        } else {
          serviceWorker.addEventListener('statechange', (e) => {
            var tmp = e.target;
            var target = tmp instanceof ServiceWorker ? tmp : THROW_CCE();
            Default_getInstance().log_iyb52q_k$(['Service worker state: ' + toString_0(target.state)]);
            var tmp_0;
            var tmp_1 = target.state;
            // Inline function 'org.w3c.workers.ACTIVATED' call
            // Inline function 'kotlin.js.asDynamic' call
            // Inline function 'kotlin.js.unsafeCast' call
            var tmp$ret$8 = 'activated';
            if (equals(tmp_1, tmp$ret$8)) {
              finishSetup(serviceWorkerReg, messaging);
              tmp_0 = Unit_instance;
            }
            return Unit_instance;
          });
          tmp_2 = Unit_instance;
        }
        tmp_0 = tmp_2;
      }
      return tmp_0;
    });
    tmp_1.catch(fcmSetup$lambda);
  } catch ($p) {
    if ($p instanceof Exception()) {
      var e = $p;
      printStackTrace(e);
    } else {
      throw $p;
    }
  }
}
function finishSetup(serviceWorker, messaging) {
  var messagingOptions = new (finishSetup$messagingOptions$1())();
  messagingOptions['vapidKey'] = 'BO5UdFoJvIrw2OLBkB9sas8i2RANMVk0-QUYKJz9fHRVYuFsAEZE8Pzhhl_VW3Wri-aZ5O1cm2Cw8ZLljgJ9jOU';
  messagingOptions['serviceWorkerRegistration'] = serviceWorker;
  // Inline function 'kotlin.js.unsafeCast' call
  var tmp = getToken(messaging, messagingOptions);
  var tmp_0 = tmp.then(finishSetup$lambda);
  tmp_0.catch(finishSetup$lambda_0);
  onMessage(messaging, (notification) => {
    var tmp0_safe_receiver = notification.notification;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.title;
    var tmp = tmp1_elvis_lhs == null ? 'Notification' : tmp1_elvis_lhs;
    var tmp2_safe_receiver = notification.notification;
    var tmp2 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.body;
    var tmp3_safe_receiver = notification.notification;
    var tmp5 = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.image;
    var tmp4_safe_receiver = notification.notification;
    // Inline function 'org.w3c.notifications.NotificationOptions' call
    // Inline function 'org.w3c.notifications.AUTO' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.unsafeCast' call
    var icon = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.icon;
    var badge = undefined;
    var sound = undefined;
    var vibrate = undefined;
    var timestamp = undefined;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var actions = [];
    var o = {};
    o['dir'] = 'auto';
    o['lang'] = '';
    o['body'] = tmp2;
    o['tag'] = '';
    o['image'] = tmp5;
    o['icon'] = icon;
    o['badge'] = badge;
    o['sound'] = sound;
    o['vibrate'] = vibrate;
    o['timestamp'] = timestamp;
    o['renotify'] = false;
    o['silent'] = false;
    o['noscreen'] = false;
    o['requireInteraction'] = false;
    o['sticky'] = false;
    o['data'] = null;
    o['actions'] = actions;
    var tmp_0 = serviceWorker.showNotification(tmp, o);
    tmp_0.catch(finishSetup$lambda$lambda);
    serviceWorker.update();
    return Unit_instance;
  });
  Default_getInstance().info_59mt0k_k$(['FCM Registration complete.']);
}
function *requestNotificationPermissions($completion) {
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  var result = yield () => {
    var uCont = $completion;
    var cancellable = new (CancellableContinuationImpl())(intercepted(uCont), 1);
    cancellable.initCancellability_shqc60_k$();
    var cont = cancellable;
    var tmp = Notification;
    tmp.requestPermission((result) => {
      // Inline function 'kotlin.coroutines.resume' call
      var this_0 = cont;
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$5 = _Result___init__impl__xyqfz8(result);
      this_0.resumeWith_rk9gbt_k$(tmp$ret$5);
      return Unit_instance;
    });
    return cancellable.getResult_fck196_k$();
  };
  // Inline function 'org.w3c.notifications.GRANTED' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.js.unsafeCast' call
  if (equals(result, 'granted')) {
    fcmSetup();
  }
  return Unit_instance;
}
function *notificationPermissions($completion) {
  var tmp;
  // Inline function 'kotlin.js.unsafeCast' call
  if ('Notification' in window) {
    var tmp0_subject = Notification.permission;
    var tmp_0;
    // Inline function 'org.w3c.notifications.GRANTED' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.unsafeCast' call
    if (equals(tmp0_subject, 'granted')) {
      tmp_0 = true;
    } else {
      // Inline function 'org.w3c.notifications.DENIED' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      if (equals(tmp0_subject, 'denied')) {
        tmp_0 = false;
      } else {
        tmp_0 = null;
      }
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
}
var fcmSetup$firebaseAppOptions$1Class;
function fcmSetup$firebaseAppOptions$1() {
  if (fcmSetup$firebaseAppOptions$1Class === VOID) {
    class $ {}
    initMetadataForClass($);
    fcmSetup$firebaseAppOptions$1Class = $;
  }
  return fcmSetup$firebaseAppOptions$1Class;
}
function fcmSetup$lambda(it) {
  printStackTrace(it);
  return Unit_instance;
}
var finishSetup$messagingOptions$1Class;
function finishSetup$messagingOptions$1() {
  if (finishSetup$messagingOptions$1Class === VOID) {
    class $ {}
    initMetadataForClass($);
    finishSetup$messagingOptions$1Class = $;
  }
  return finishSetup$messagingOptions$1Class;
}
function finishSetup$lambda(it) {
  get_fcmToken().set_value_v1vabv_k$(it);
  return Unit_instance;
}
function finishSetup$lambda_0(it) {
  printStackTrace(it);
  return Unit_instance;
}
function finishSetup$lambda$lambda(e) {
  console.error('Error sending notificaiton to user', e);
  return Unit_instance;
}
//region block: exports
export {
  notificationPermissions as notificationPermissions3o42d5ddpz7h,
  requestNotificationPermissions as requestNotificationPermissionsg3jo4mpz20gg,
  fcmSetup as fcmSetup15yguhbnhle9q,
};
//endregion

//# sourceMappingURL=fcmSetup.js.mjs.map
